// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"d4812661","410":"0a3f7b46","437":"22505b36"}[chunkId] + ".chunk.js";
};